'use client'

import { useRouter } from 'next/navigation'

import { ACADEMY_ROUTES } from '@/shared/academy.const'

import { CtaFooter } from './components/CtaFooter'
import { HeroSection } from './components/HeroSection'
import { LearningPathsSection } from './components/LearningPathsSection'

import styles from './styles.module.scss'

export function AcademyPage() {
  const router = useRouter()

  const handleTryGraftcode = () => {
    const portalUrl = process.env.NEXT_PUBLIC_WEB_PORTAL_URL || 'https://portal.graftcode.com'
    window.location.href = portalUrl
  }

  const handleQuickStart = () => {
    router.push(ACADEMY_ROUTES.quickStart)
  }

  return (
    <div className={styles.container}>
      <HeroSection onTryGraftcode={handleTryGraftcode} onQuickStart={handleQuickStart} />
      <LearningPathsSection />
      {/* <PopularTopicsSection /> */}
      <CtaFooter onTryGraftcode={handleTryGraftcode} />
    </div>
  )
}
